import styled from "styled-components"

export const TitleContainer = styled.div`
  padding: 0;
`
